import "./Home.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Register from "../Register/Register";
import { useEffect, useState } from "react";
import img from "../images/IMG-20240723-WA0006.jpg";
import img2 from "../images/IMG-20240723-WA0008.jpg";
import img3 from "../images/IMG-20240723-WA0013.jpg";
import img4 from "../images/IMG-20240723-WA0018.jpg";
import img5 from "../images/IMG-20240723-WA0021.jpg";
import img6 from "../images/IMG-20240723-WA0022.jpg";
import img7 from "../images/IMG-20240723-WA0023.jpg";
import icon9 from "../Icons/Icon-09.png";
import { showRegister, searsh_product } from "../Redux/HomeSlice";
import "react-tooltip/dist/react-tooltip.css";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Group from '../images/Group 2.svg'
import Searsh from '../Searsh/Searsh'



import {
  category,
  brands,
  recommended,
  offers,
  collections,
  new_arrivals,
  best_of,
  store,
  influencer,
  ads,
  latest,
  favorites,
  product_reviews,
  add_wishlist,
  show_brand,
  ad_details,
  myProfile,
  get_footer,
  remove_favorites,
  addFavorite,
  show_Influencer,
  show_store,
  filter_data,
  sort_data,
  product_details,
} from "../Redux/API";
import { category_data } from "../Redux/HomeSlice";
import {
  faChevronLeft,
  faChevronRight,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useTranslation } from "react-i18next";

function Home() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();



  const gotoProductDetails = (product) => {
    localStorage.setItem("Product_id", product.id);
    dispatch(product_details(product.id));
    dispatch(product_reviews(product.id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));


    const id = product?.type?.id;
    if (!id || !product?.vendor_type) return;

    switch (product.vendor_type) {
      case "brand":
          localStorage.setItem('brandId', id);
          dispatch(show_brand({ id }));
          break;
      case "influencer":
          localStorage.setItem('InfluencerId', id);
          dispatch(show_Influencer({ id }));
          break;
      case "store":
          localStorage.setItem('storeId', id);
          dispatch(show_store({ id }));
          break;
      default:
          console.error("Unknown vendor type:", product.vendor_type);
    }
  };


  const gotoCategory = (category) => {
    if (category?.id) { // التحقق من وجود parent_id داخل الكائن
    dispatch(filter_data({influencer_id: null, brand_id: null, store_id: null, category_id: category.id}));
    dispatch(sort_data({influencer_id: null, brand_id: null, store_id: null, category_id: category.id}));
    localStorage.setItem("categoryData", JSON.stringify(category));
    dispatch(category_data(category));
    navigate("/SubSupCategory");
    window.scrollTo(0, 0);
    }
  };

  const gotoBrand = (id) => {
    localStorage.setItem("brandId", id);
    dispatch(filter_data({influencer_id: null, brand_id: id, store_id: null}));
    dispatch(sort_data({influencer_id: null, brand_id: id, store_id: null}));
    dispatch(show_brand({ id }));
    window.scrollTo(0, 0);
    navigate("/Brand");
    
  };

  const gotoInfluencer = (id) => {
    localStorage.setItem("InfluencerId", id);
    dispatch(filter_data({influencer_id: id, brand_id: null, store_id: null}));
    dispatch(sort_data({influencer_id: id, brand_id: null, store_id: null}));
    window.scrollTo(0, 0);
    dispatch(show_Influencer({ id }));
    navigate("/Influencer");

  };

  const gotoStore = (id) => {
    localStorage.setItem("storeId", id);
    dispatch(filter_data({influencer_id: null, brand_id: null, store_id: id}));
    dispatch(sort_data({influencer_id: null, brand_id: null, store_id: id}));
    dispatch(show_store({ id }));
    window.scrollTo(0, 0);
    navigate("/Store");

  };


  const adss = useSelector((state) => state.Data.ads);
console.log(adss)
const handleNavigate = (id, type) => {
  // const ids = id;
    // if (!id || !type) return;
    // console.log(id)

    switch (type || id) {
        case "brand":
            gotoBrand(id);
            break;
        case "influencer":
            gotoInfluencer(id);
            break;
        case "store":
            gotoStore(id);
            break;
        case "category":
            gotoStore(id);
            dispatch(filter_data({influencer_id: null, brand_id: null, store_id: id}));
            dispatch(sort_data({influencer_id: null, brand_id: null, store_id: id}));
            break;
        default:
            console.error("Unknown vendor type:", adss?.data?.data?.ad_type);
    }
};



  const brand = useSelector((state) => state.Data.brands);
  const loadingBrands = useSelector((state) => state.Data.loadingBrands);








  const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
  const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);

  const footer = useSelector((state) => state?.Data?.get_footer);
  const loadingGet_footer = useSelector((state) => state.Data.loadingGet_footer);
  const loadingAddFavorite = useSelector((state) => state.Data.loadingAddFavorite);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const showR = useSelector((state) => state?.products?.showR);

  useEffect(() => {
    if (!loadingAddFavorite && !loadingRemove_favorites) {
      dispatch(favorites()); // قم بتحديث المفضلة بعد الإضافة أو الحذف
    }
  }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);

  const handelAdd_wishlist = (id, event) => {
    if (token) {
      const isInWishlist = favorite?.some((item) => item.product_id === id);
      if (isInWishlist) {
        dispatch(remove_favorites(id));
      } else {
        dispatch(addFavorite({ id }));
      }
    } else {
      const { pageY } = event;
      const offsetY = -100;
      setPopupPosition({ x: 50, y: pageY + offsetY }); 
      dispatch(showRegister(true));
    }
  };



  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };

  const categorys = useSelector((state) => state.Data.category);

  const recommendeds = useSelector((state) => state.Data.recommended);

  const offer = useSelector((state) => state.Data.offers);

  const collection = useSelector((state) => state.Data.collections);

  const new_arrival = useSelector((state) => state.Data.new_arrivals);

  const best_ofs = useSelector((state) => state.Data.best_of);

  const Stores = useSelector((state) => state.Data.store);

  const influencers = useSelector((state) => state.Data.influencer);

  const [currentIndex, setCurrentIndex] = useState(0);
  const images = adss?.data?.data || [];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // تغيير الصورة كل خمس ثواني

    return () => clearInterval(interval);
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const imagess = brand?.data?.data?.brands || [];
  const imagess1 = recommendeds?.data?.data || [];

  const imagess2 = best_ofs?.data?.data || [];
  
  const images4 = offer?.data?.data || [];

  const images5 = collection?.data?.data || [];

  const images3 = new_arrival?.data?.data || [];

  const images6 = Stores?.data?.data || [];

  const images7 = influencers?.data?.data || [];

  const [startIndex, setStartIndex] = useState(0);
  const [startIndex1, setStartIndex1] = useState(0);
  const [startIndex2, setStartIndex2] = useState(0);
  const [startIndex3, setStartIndex3] = useState(0);
  const [startIndex4, setStartIndex4] = useState(0);
  const [startIndex5, setStartIndex5] = useState(0);
  const [startIndex6, setStartIndex6] = useState(0);
  const [startIndex7, setStartIndex7] = useState(0);
  const [startIndex8, setStartIndex8] = useState(0);

  // const [isTransitioning, setIsTransitioning] = useState(false);
  // const handleNext = () => {
  //   const maxIndex = imagess1?.length - getVisibleCount();
  //   console.log("current startIndex:", startIndex);
  //   console.log("maxIndex:", maxIndex);
  
  //   if (startIndex >= maxIndex) {
  //     setIsTransitioning(false);
  //     return;
  //   }
  
  //   setIsTransitioning('exit-left');
  //   setTimeout(() => {
  //     setStartIndex(prevStartIndex => {
  //       const newStartIndex = Math.min(prevStartIndex + getVisibleCount(), imagess1.length - getVisibleCount());
  //       console.log("newStartIndex:", newStartIndex);
  //       return newStartIndex;
  //     });
  //     setIsTransitioning('enter-from-right');
  //     setTimeout(() => {
  //       setIsTransitioning(false);
  //     }, 500);
  //   }, 500);
  // };
  
  // const handlePrev = () => {
  //   // تحقق إذا كنا في أول مجموعة بالفعل
  //   if (startIndex <= 0) return;
  
  //   setIsTransitioning('exit-right'); // تفعيل حركة الخروج من اليمين
  //   setTimeout(() => {
  //     setStartIndex(startIndex - getVisibleCount()); // تحديث المجموعة للسابقة
  //     setIsTransitioning('enter-from-left'); // تفعيل حركة الدخول من اليسار
  //     setTimeout(() => {
  //       setIsTransitioning(false); // إنهاء الحركة بعد ظهور العناصر الجديدة
  //     }, 500); // نفس مدة الحركة في CSS
  //   }, 500);
  // };
  
  const getVisibleCount = () => {
    if (window.innerWidth >= 1400) return 4; // شاشات XL
    if (window.innerWidth >= 1200) return 4; // شاشات LG
    if (window.innerWidth >= 992) return 3; // شاشات MD
    if (window.innerWidth >= 768) return 3; // شاشات SM
    return 3; // شاشات XS - الشاشات الصغيرة جداً
  };
  const getVisibleCount10 = () => {
    if (window.innerWidth >= 1400) return 8; // شاشات XL
    if (window.innerWidth >= 1200) return 4; // شاشات LG
    if (window.innerWidth >= 992) return 3; // شاشات MD
    if (window.innerWidth >= 768) return 3; // شاشات SM
    return 3; // شاشات XS - الشاشات الصغيرة جداً
  };
  const getVisibleCountProduct = () => {
    if (window.innerWidth >= 1400) return 5; // شاشات XL
    if (window.innerWidth >= 1200) return 5; // شاشات LG
    if (window.innerWidth >= 992) return 4; // شاشات MD
    if (window.innerWidth >= 768) return 3; // شاشات SM
    if (window.innerWidth >= 576) return 3; // شاشات SM
    return 2; // شاشات XS - الشاشات الصغيرة جداً
  };
  
  // const handleNext = () => {
  //   if (startIndex + getVisibleCount() < imagess?.length) {
  //     setStartIndex(startIndex + 1);
  //   }
  // };

  // const handlePrev = () => {
  //   if (startIndex > 0) {
  //     setStartIndex(startIndex - 1);
  //   }
  // };
  const isRTL = document.dir === "rtl"; // يتحقق من اتجاه اللغة
  const [animationDirection, setAnimationDirection] = useState("next");
  const [animationDirectionStore, setAnimationDirectionStore] = useState("next"); 

  const handleNext = () => {
    const visibleCount = getVisibleCount();
    if (startIndex + visibleCount < imagess.length) {
      setAnimationDirection("next"); // تحديد الاتجاه
      setStartIndex(startIndex + visibleCount);
    }
  };
  
  const handlePrev = () => {
    const visibleCount = getVisibleCount();
    if (startIndex - visibleCount >= 0) {
      setAnimationDirection("prev"); // تحديد الاتجاه
      setStartIndex(startIndex - visibleCount);
    }
  };
  


  const handleNext1 = () => {
    if (startIndex1 + getVisibleCountProduct() < imagess1?.length) {
      setStartIndex1(startIndex1 + 1);
    }
  };

  

  const handlePrev1 = () => {
    if (startIndex1 > 0) {
      setStartIndex1(startIndex1 - 1);
    }
  };

  const handleNext2 = () => {
    if (startIndex2 + getVisibleCountProduct() < imagess2?.length) {
      setStartIndex2(startIndex2 + 1);
    }
  };

  const handlePrev2 = () => {
    if (startIndex2 > 0) {
      setStartIndex2(startIndex2 - 1);
    }
  };

  const handleNext3 = () => {
    if (startIndex3 + getVisibleCountProduct() < images3?.length) {
      setStartIndex3(startIndex3 + 1);
    }
  };

  const handlePrev3 = () => {
    if (startIndex3 > 0) {
      setStartIndex3(startIndex3 - 1);
    }
  };

  const handleNext4 = () => {
    if (startIndex4 + getVisibleCountProduct() < images4?.length) {
      setStartIndex4(startIndex4 + 1);
    }
  };

  const handlePrev4 = () => {
    if (startIndex4 > 0) {
      setStartIndex4(startIndex4 - 1);
    }
  };

  const handleNext5 = () => {
    if (startIndex5 + getVisibleCountProduct() < images5.length) {
      setStartIndex5(startIndex5 + 1);
    }
  };

  const handlePrev5 = () => {
    if (startIndex5 > 0) {
      setStartIndex5(startIndex5 - 1);
    }
  };

  // const handleNext6 = () => {
  //   if (startIndex6 + getVisibleCount() < images6?.length) {
  //     setStartIndex6(startIndex6 + 1);
  //   }
  // };

  // const handlePrev6 = () => {
  //   if (startIndex6 > 0) {
  //     setStartIndex6(startIndex6 - 1);
  //   }
  // };


  const handleNext6 = () => {
    const visibleCount = getVisibleCount();
    if (startIndex6 + visibleCount < images6.length) {
      setAnimationDirectionStore("next"); // تحديد الاتجاه
      setStartIndex6(startIndex6 + visibleCount);
    }
  };
  
  const handlePrev6 = () => {
    const visibleCount = getVisibleCount();
    if (startIndex6 - visibleCount >= 0) {
      setAnimationDirectionStore("prev"); // تحديد الاتجاه
      setStartIndex6(startIndex6 - visibleCount);
    }
  };


  // const handleNext7 = () => {
  //   if (startIndex7 + getVisibleCount() < images7?.length) {
  //     setStartIndex7(startIndex7 + 1);
  //   }
  // };

  // const handlePrev7 = () => {
  //   if (startIndex7 > 0) {
  //     setStartIndex7(startIndex7 - 1);
  //   }
  // };
  const handleNext7 = () => {
    const visibleCount = getVisibleCount();
    if (startIndex7 + visibleCount < images7.length) {
      setAnimationDirection("next"); // تحديد الاتجاه
      setStartIndex7(startIndex7 + visibleCount);
    }
  };
  
  const handlePrev7 = () => {
    const visibleCount = getVisibleCount();
    if (startIndex7 - visibleCount >= 0) {
      setAnimationDirection("prev"); // تحديد الاتجاه
      setStartIndex7(startIndex7 - visibleCount);
    }
  };

  // const getVisibleImages = () => {
  //   const visibleCount = getVisibleCount();
  //   return imagess.slice(startIndex, startIndex + visibleCount);
  // };
  const getVisibleImages = () => {
    const visibleCount = getVisibleCount();
    return imagess.slice(startIndex, startIndex + visibleCount).map((brand, index) => ({
      ...brand,
      animation: startIndex > 0 ? "slideIn 0.5s ease-in-out" : "slideOut 2s ease-in-out",
    }));
  };

  const getVisibleImages1 = () => {
    return imagess1?.slice(startIndex1, startIndex1 + getVisibleCountProduct());
  };
  const getVisibleImages2 = () => {
    return imagess2?.slice(startIndex2, startIndex2 + getVisibleCountProduct());
  };
  const getVisibleImages3 = () => {
    return images3?.slice(startIndex3, startIndex3 + getVisibleCountProduct());
  };
  const getVisibleImages4 = () => {
    return images4?.slice(startIndex4, startIndex4 + getVisibleCountProduct());
  };
  const getVisibleImages5 = () => {
    return images5?.slice(startIndex5, startIndex5 + getVisibleCountProduct());
  };

  // const getVisibleImages6 = () => {
  //   return images6?.slice(startIndex6, startIndex6 + getVisibleCount());
  // };
  const getVisibleImages6 = () => {
    const visibleCount = getVisibleCount();
    return images6.slice(startIndex6, startIndex6 + visibleCount).map((store, index) => ({
      ...store,
      animation: startIndex6 > 0 ? "slideIn 0.5s ease-in-out" : "slideOut 2s ease-in-out",
    }));
  };

  // const getVisibleImages7 = () => {
  //   return images7?.slice(startIndex7, startIndex7 + getVisibleCount());
  // };
  const getVisibleImages7 = () => {
    const visibleCount = getVisibleCount();
    return images7.slice(startIndex7, startIndex7 + visibleCount).map((influencer, index) => ({
      ...influencer,
      animation: startIndex7 > 0 ? "slideIn 0.5s ease-in-out" : "slideOut 2s ease-in-out",
    }));
  };

  const getVisibleImages8 = () => {
    return images_difalt?.slice(startIndex8, startIndex8 + getVisibleCountProduct());
  };
  const getVisibleImages9 = () => {
    return images_difalt?.slice(startIndex8, startIndex8 + getVisibleCount());
  };
  const getVisibleImages10 = () => {
    return images_difalt?.slice(startIndex8, startIndex8 + getVisibleCount10());
  };

  const [visibleImage, setVisibleImage] = useState(8);
  const [showMore, setShowMore] = useState(false);

  const toggleImages = () => {
    setShowMore(!showMore);
    if (showMore) {
      setVisibleImage(8); // إخفاء الصور الإضافية
    } else {
      setVisibleImage(categorys.length); // عرض جميع الصور
    }
  };

  const cookie_id = "54c14fce-c8c8-472e-b987-7457ebfe13f9";
  useEffect(() => {
    dispatch(category());
    dispatch(brands());
    dispatch(recommended());
    dispatch(offers());
    dispatch(new_arrivals());
    dispatch(best_of());
    dispatch(store());
    dispatch(influencer());
    dispatch(ads());
    dispatch(latest());
    dispatch(collections());
    dispatch(get_footer());
    dispatch(favorites({ user_id: cookie_id }));
  }, [dispatch]);

  const images_difalt = [
    {
      src: img,
      title: "Photo 1",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img2,
      title: "Photo 2",
      p: "AMERIX BIO TIN 60 PIECES hello mohamed",
      price: "469.000",
    },
    {
      src: img3,
      title: "Photo 3",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img4,
      title: "Photo 4",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img5,
      title: "Photo 5",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img6,
      title: "Photo 6",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img7,
      title: "Photo 6",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img7,
      title: "Photo 6",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
  ];

  const show_searsh = useSelector((state) => state?.products?.searsh);
  const loadingSearsh_brand = useSelector(
    (state) => state.Data.loadingSearsh_brand
  );
  const searsh = useSelector((state) => state.Data.searsh_brand);
console.log(searsh)


  return (
    <div className="Home">
      <Header />
      {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

      {show_searsh && (
        <Searsh /> 
      )}

      <div className="carousel container">
        <i className="font-size2" onClick={prevSlide}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </i>
        <img
          onClick={() => handleNavigate(images[currentIndex]?.type_info?.id, images[currentIndex]?.type_info?.category)}
          src={images[currentIndex]?.image_url || Group}
          alt={`slide ${currentIndex}`}
        />

        <i className="font-size2" onClick={nextSlide}>
          <FontAwesomeIcon icon={faChevronRight} />
        </i>
        <div className="dots-container">
          {images.map((e, index) => (
            <>
              <span
                key={index}
                className={`dot ${currentIndex === index ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              ></span>
            </>
          ))}
        </div>
      </div>


      <div className="containerGallery container mt-5 g-0">
  <div className="row align-items-center justify-content-between g-0">
    <div className="col-1 icon g-0">
      <img src={icon9} className="iconLeft" onClick={handlePrev} />
    </div>
    {(getVisibleImages()?.length > 0
      ? getVisibleImages()
      : getVisibleImages9()
    ).map((brand, index) => (
      <div
      key={`${brand.id}-${index}`}
      style={{
        animation: `${
          animationDirection === "next"
            ? isRTL
              ? "slideInFromLeft"
              : "slideInFromRight" 
            : isRTL
            ? "slideInFromRight"
            : "slideInFromLeft"
        } 0.5s ease-in-out`,
      }}
      className={`col-${
        window.innerWidth >= 1400
          ? 2
          : window.innerWidth >= 1200
          ? 2
          : window.innerWidth >= 992
          ? 2
          : window.innerWidth >= 768
          ? 3
          : window.innerWidth >= 576
          ? 3
          : 3
      }`}
      >
        <p onClick={() => gotoBrand(brand?.id)} className="bordar">
          <img src={brand?.logo || Group} alt={`img-${index}`} />
          <p className="NameBrand">{brand?.name}</p>
        </p>
      </div>
    ))}
    <div className="col-1 icon g-0">
      <img src={icon9} className="iconRitgh" onClick={handleNext} />
    </div>
  </div>
</div>




{/* <div className="containerGallery container mt-5 g-0">
        <div className="row align-items-center justify-content-between g-0">
          <div className="col-1 icon g-0">
            <img src={icon9} className="iconLeft" onClick={handlePrev} />
          </div>
          {(getVisibleImages()?.length > 0
                ? getVisibleImages()
                : getVisibleImages9()
              ).map((brand, index) => (
              <div
                key={index}
                style={{animation: `slideIn 0.5s ease-in-out`}}
                className={`col-${
                  window.innerWidth >= 1400
                    ? 2
                    : window.innerWidth >= 1200
                    ? 2
                    : window.innerWidth >= 992
                    ? 2
                    : window.innerWidth >= 768
                    ? 3
                    : window.innerWidth >= 576
                    ? 3
                    : 3
                }`}
              >
                <p onClick={() => gotoBrand(brand?.id)} className="bordar">
                  <img src={brand?.logo || Group } alt={`img-${index}`} />
                <p className="NameBrand">{brand?.name}</p>
                </p>
              </div>
            ))}
          <div className="col-1 icon g-0">
            <img src={icon9} className="iconRitgh" onClick={handleNext} />
          </div>
        </div>
      </div> */}



      <div className=" container_grid container">
        <div className="bordar">
          <div className="colorwhite ">
            <div className="row justify-content-around text-center align-i g-0">
              
              {(categorys?.data?.data?.slice(0, visibleImage)?.length > 0
                ? categorys?.data?.data?.slice(0, visibleImage)
                : getVisibleImages10()
              ).map((e, index) => (
                <div
                  key={index}
                  className={`col-5 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-3 text-center `}
                >
                  <p className="text-center" onClick={() => gotoCategory(e)}>
                    <img key={index} src={e.image || Group} alt={`Image ${index + 1}`} />
                  </p>
                  <p>{e.name}</p>
                </div>
              ))}
            </div>
            {categorys?.data?.data?.length > 8 && (
              <div
                onClick={toggleImages}
                className="show-more col-5 col-md-3 col-lg-2 justify-content-center"
              >
                {showMore ? ` ${t("HIDE")}` : `${t("SHOW MORE")}`}
              </div>
             )}
          </div>
        </div>
      </div>

      <div className="img12 container">
        <img src={images[3]?.image_url || Group}/>
      </div>

      <div className="title_slider container">
        <p className="font-size2">{t("Recommend for You")}</p>
      </div>

      <div className="gallery1 container">

        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev1} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
          {(getVisibleImages1()?.length > 0
            ? getVisibleImages1()
            : getVisibleImages8()
          ).map((product, index) => {
            const isInWishlist = favorite?.some(
              (item) => item.product_id === product.id
            );

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                  <div className="padding_box" onClick={() => gotoProductDetails(product)} >
                    <i
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="ده التولتيب بتاعي"
                      onClick={(event) => {
                        event.stopPropagation();
                        handelAdd_wishlist(product.id, event);
                      }}
                      style={{ color: isInWishlist ? "red" : "white" }}
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext1} />
        </div>
      </div>

      <div className="img12 container">
        <img src={images[2]?.image_url || Group}/>
      </div>

      <div className="title_slider container">
        <p className="font-size2">{t("Best of")}</p>
      </div>

      <div className="gallery1 container">

        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev2} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
          {(getVisibleImages2()?.length > 0
            ? getVisibleImages2()
            : getVisibleImages8()
          ).map((product, index) => {
            const isInWishlist = favorite?.some(
              (item) => item.product_id === product.id
            ); // تحقق من وجود المنتج في الوشليست

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                  <div className="padding_box" onClick={() => gotoProductDetails(product)} >
                    <i
                      onClick={(event) => {
                        handelAdd_wishlist(product.id, event);
                        event.stopPropagation();
                      }}
                      style={{ color: isInWishlist ? "red" : "white" }} // تغيير لون الأيقونة
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext2} />
        </div>
      </div>

      <div className="img12 container">
        <img src={images[1]?.image_url || Group}/>
      </div>

      <div className="title_slider container">
        <p className="font-size2">{t("New arrival")}</p>
      </div>

      <div className="gallery1 container">
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev3} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
          {(getVisibleImages3()?.length > 0
            ? getVisibleImages3()
            : getVisibleImages8()
          ).map((product, index) => {
            const isInWishlist = favorite?.some(
              (item) => item.product_id === product.id
            ); // تحقق من وجود المنتج في الوشليست

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                  <div className="padding_box" onClick={() => gotoProductDetails(product)} >
                    <i
                      onClick={(event) => {
                        handelAdd_wishlist(product.id, event);
                        event.stopPropagation();

                      }}
                      style={{ color: isInWishlist ? "red" : "white" }} // تغيير لون الأيقونة
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext3} />
        </div>
      </div>

      <div className="img12 container" onClick={() => handleNavigate(images[0]?.type_info?.id, images[0]?.ad_type)}>
        <img src={images[0]?.image_url || Group}/>
      </div>

      <div className="title_slider container">
        <p className="font-size2">{t("Offers")}</p>
      </div>

      <div className="gallery1 container">
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev4} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
          {(getVisibleImages4()?.length > 0
            ? getVisibleImages4()
            : getVisibleImages8()
          ).map((product, index) => {
            const isInWishlist = favorite?.some(
              (item) => item.product_id === product.id
            ); // تحقق من وجود المنتج في الوشليست

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                  <div className="padding_box" onClick={() => gotoProductDetails(product)} >
                    <i
                      onClick={(event) => {
                        handelAdd_wishlist(product.id, event);
                        event.stopPropagation();

                      }}
                      style={{ color: isInWishlist ? "red" : "white" }} // تغيير لون الأيقونة
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext4} />
        </div>
      </div>

      <div className="title_slider container">
        <p className="font-size2">{t("Whats hot in category")}</p>
      </div>
      <div className="gallery1 container">
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev5} />
        </div>
        <div className="mm row align-items-center justify-content-between g-0">
            {(getVisibleImages5()?.length > 0
              ? getVisibleImages5()
              : getVisibleImages8()
            ).map((item, index) => (
            <div 
              className="box2 col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-2 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
              key={index}
              onClick={() => gotoCategory(item)}            >
              <img
                className="img_box2"
                key={index}
                src={item.image || Group }
                alt={`img-${index}`}
              />
            </div>
          ))}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext5} />
        </div>
      </div>

      <div className="title_slider container">
        <p className="font-size2">{t("Store")}</p>
      </div>


      <div className="containerGallery container mt-5 g-0">
        <div className="row align-items-center justify-content-between g-0">
          <div className="col-1 icon g-0">
            <img src={icon9} className="iconLeft" onClick={handlePrev6} />
          </div>
          {(getVisibleImages6()?.length > 0
              ? getVisibleImages6()
              : getVisibleImages9()
            ).map((store, index) => (
            <div
            key={`${store.id}-${index}`}
            style={{
              animation: `${
                animationDirectionStore === "next"
                  ? isRTL
                    ? "slideInFromLeft"
                    : "slideInFromRight" 
                  : isRTL
                  ? "slideInFromRight"
                  : "slideInFromLeft"
              } 0.5s ease-in-out`,
            }}
            className={`col-${
              window.innerWidth >= 1400
                ? 2
                : window.innerWidth >= 1200
                ? 2
                : window.innerWidth >= 992
                ? 2
                : window.innerWidth >= 768
                ? 3
                : window.innerWidth >= 576
                ? 3
                : 3
            }`}
            >
              <p onClick={() => gotoStore(store?.id)} className="bordar">
                <img src={store?.image || Group} alt={`img-${index}`} />
                <p className="NameBrand">{store?.name}</p>
              </p>
            </div>
          ))}
          <div className="col-1 icon g-0">
            <img src={icon9} className="iconRitgh" onClick={handleNext6} />
          </div>
        </div>
        <div className="hr"></div>
      </div>


      <div className="title_slider container">
        <p className="font-size2">{t("Influencer")}</p>
      </div>


      <div className="containerGallery container mt-5 g-0">
        <div className="row align-items-center justify-content-between g-0">
          <div className="col-1 icon g-0">
            <img src={icon9} className="iconLeft" onClick={handlePrev7} />
          </div>
          {(getVisibleImages7()?.length > 0
              ? getVisibleImages7()
              : getVisibleImages9()
            ).map((influencer, index) => (
            <div
            key={`${influencer.id}-${index}`}
            style={{
              animation: `${
                animationDirection === "next"
                  ? isRTL
                    ? "slideInFromLeft"
                    : "slideInFromRight" 
                  : isRTL
                  ? "slideInFromRight"
                  : "slideInFromLeft"
              } 0.5s ease-in-out`,
            }}
            className={`col-${
              window.innerWidth >= 1400
                ? 2
                : window.innerWidth >= 1200
                ? 2
                : window.innerWidth >= 992
                ? 2
                : window.innerWidth >= 768
                ? 3
                : window.innerWidth >= 576
                ? 3
                : 3
            }`}
            >
              <p onClick={() => gotoInfluencer(influencer?.id)} className="bordar">
                <img src={influencer?.image || Group } alt={`img-${index}`} />
                <p className="NameBrand">{influencer.name}</p>
              </p>
            </div>
          ))}
          <div className="col-1 icon g-0">
            <img src={icon9} className="iconRitgh" onClick={handleNext7} />
          </div>
        </div>
      </div>
      <div className="hr"></div>

      <div className="foot container">
        <div className="row">
          <h2 className="h2 col-12 col-md-6">
            {t("YOUR ONE-STEP SHOP TO")}
            <br />
            {t("ALL WHAT YOU NEED")}
          </h2>
          <div className="col-3 m-auto mt-4 mt-md-0">
            <div>
              <h2>{footer?.data.data.statistics.employers}+</h2>
              <p>{t("EMPLOYERS")}</p>
            </div>
            <div>
              <h2>{footer?.data.data.statistics.products}+</h2>
              <p>{t("PRODUCTS")}</p>
            </div>
          </div>
          <div className="col-3 m-auto mt-4 mt-md-0">
            <div>
              <h2>{footer?.data.data.statistics.languages}+</h2>
              <p>{t("LANGUAGES")}</p>
            </div>
            <div>
              <h2>{footer?.data.data.statistics.warehouses}</h2>
              <p>{t("WAREHOUSES")}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer Sign_Up={Sign_Up} />
    </div>
  );
}

export default Home;
